import { Fragment, useState, useEffect } from 'react';
import { useGetContratosQuery } from "../../../redux/reducers/contratosSlice";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import {
    Button, Box, DialogTitle, Dialog, Typography, DialogContent, OutlinedInput, FormHelperText, FormControl
} from '@mui/material';
import {
    DataGridPro, GridToolbarQuickFilter, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
    GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
  } from '@mui/x-data-grid-pro';
import ComisionesDetailModal from './comisionesDetailModal/ComisionesDetailModal';
import { random } from 'lodash';
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import theme from "../../../theme";
import { getData } from "./ComisionesCatSlice.js";

const moneyFormat = v => '$' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'ARS' }).format(parseInt(v) / 100).replace("ARS", "");

const ComisionesCat = () => {
    const dispatch = useDispatch();
    const fetching = useSelector(state => state.comisiones.fetching);
    const comisiones = useSelector(state => state.comisiones.data);
    const currentUser = useSelector(selectCurrentUser);
    const [showComisionesDetails, setShowComisionesDetails] = useState(false)
    const { data: contratos, isLoading, isSuccess, isError, error } = useGetContratosQuery();
    useEffect(() => { dispatch(getData()) }, []);
    useEffect(() => { console.log(comisiones) }, [comisiones]);

    const Header = (props) => {
        return (<Fragment>
            <Typography
                variant="h5"
                component="div"
                sx={{
                    minWidth: 275, margin: "10px",
                    display: 'flex',
                    alignItems: 'center'
                }}
            >

                {'Comisiones Vendedores'}</Typography>
            {isLoading && <p>Cargando</p>}
            {isError && <p>Ha ocurrido un error</p>}
        </Fragment>);
    };

    const BtnBar = (props) => {
        const [showNuevoContratoForm, setShowNuevoContratoForm] = useState(false);

        const openForm = () => setShowNuevoContratoForm(true);
        const closeForm = () => setShowNuevoContratoForm(false);

        const NuevoContratoForm = () => {
            return (
                <Dialog onClose={closeForm} open={showNuevoContratoForm}>
                    <DialogTitle>Dar de alta nuevo precontrato: </DialogTitle>
                    <DialogContent dividers>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <div>
                                <FormControl fullWidth sx={{ m: 1 }}>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                    />
                                    <FormHelperText id="outlined-weight-helper-text">Vendedor</FormHelperText>
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined">
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                    />
                                    <FormHelperText id="outlined-weight-helper-text">Serie</FormHelperText>
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined">
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                    />
                                    <FormHelperText id="outlined-weight-helper-text">Clase</FormHelperText>
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined">
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                    />
                                    <FormHelperText id="outlined-weight-helper-text">Prima</FormHelperText>
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined">
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                    />
                                    <FormHelperText id="outlined-weight-helper-text">Adelanto Inicial</FormHelperText>
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined">
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                    />
                                    <FormHelperText id="outlined-weight-helper-text">Socios...</FormHelperText>
                                </FormControl>
                            </div>
                            <Button onClick={closeForm}>{"Cancelar"}</Button>
                            <Button onClick={closeForm}>{"Aceptar"}</Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            )
        }

        return (
            <Fragment>
                <Button onClick={openForm}>{"Nuevo"}</Button>
                <NuevoContratoForm></NuevoContratoForm>
            </Fragment>
        );
    };

    const ComisionesTable = (props) => {

        const getLastNMonths = (n = 6) => {
            const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
            let res = [];
            for (let i = n; i > 0; i--) {
                let d = new Date();
                d.setMonth(d.getMonth() - i);
                let k = `${meses[d.getMonth()]}-${d.getFullYear() % 1000}`;
                res.push({
                    field: k,
                    headerName: k,
                    flex: 60,
                    valueGetter: v => {
                        const formatter = new Intl.NumberFormat('es-ES', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2, });
                        let example = {
                            "contratoId": 125,
                            "serie": "1",
                            "claseContratoId": 1,
                            "vendedorId": 12,
                            "perPrimaAdjudicacion": 0,
                            "adelantoInicialNominal": "0",
                            "adelantoRecurrenteCAC": 6.484702e-7,
                            "mesRefuerzoSemestral1": null,
                            "mesRefuerzoSemestral2": null,
                            "fechaFirma": "1690997926000",
                            "fechaPerfeccionamiento": "1690997926000",
                            "referenciadoId": null,
                            "cuponDePagoMensualCuotas": null,
                            "editorId": 6,
                            "fechaEdicion": "1704215497973",
                            "contratoPrincipalId": null,
                            "creadorId": 19,
                            "fechaCreacion": "1690997926000",
                            "estado": true,
                            "etapa": 1,
                            "fechaAplicacionDesde": "1690997926000",
                            "fechaAplicacionHasta": null,
                            "clasesContrato": {
                                "claseContratoId": 1,
                                "descripcion": "Monoambiente en distrito Qiudad",
                                "codigo": "1AMB-STD-QI",
                                "m2Eq": 18,
                                "valorObjetoAhorroCAC": 7515.9,
                                "nCuotas": 350,
                                "perBonificiacionAdelantoInicial": 0.17,
                                "perBonificiacionAdelantoEspontaneo": 0.05,
                                "perBonificiacionAdelantoRecurrente": 0.1,
                                "perBonificiacionLicitacion": 0,
                                "perPrimaAdjudicacionMin": 0,
                                "perPrimaAdjudicacionMax": 0.3,
                                "perCuotaPosesion": 1.6,
                                "perCuotaMin": 0.5,
                                "perCuotaMax": 5,
                                "principal": true
                            },
                            "indice": {
                                "indiceId": 163,
                                "fecha": "1688126463000",
                                "cac": "366220",
                                "cvs": "0",
                                "blue": "0",
                                "mep": "0",
                                "turista": "0",
                                "oficial": "0",
                                "editorId": 6,
                                "fechaEdicion": "1690113684474"
                            },
                            "pagos": [
                                {
                                    "pagoId": 377,
                                    "montoNominal": "9500000",
                                    "fecha": "1690998053000",
                                    "fechaValor": "1690998053000",
                                    "contratoId": 125,
                                    "medioDePagoId": 1,
                                    "intencionPagoId": null,
                                    "refId": "611299",
                                    "descripcion": null,
                                    "editorId": 19,
                                    "fechaEdicion": "1691602854328"
                                },
                                {
                                    "pagoId": 585,
                                    "montoNominal": "10381200",
                                    "fecha": "1696011160000",
                                    "fechaValor": "1696011160000",
                                    "contratoId": 125,
                                    "medioDePagoId": 1,
                                    "intencionPagoId": null,
                                    "refId": "377407",
                                    "descripcion": null,
                                    "editorId": 8,
                                    "fechaEdicion": "1696443160640"
                                },
                                {
                                    "pagoId": 712,
                                    "montoNominal": "12424900",
                                    "fecha": "1698767975000",
                                    "fechaValor": "1698767975000",
                                    "contratoId": 125,
                                    "medioDePagoId": 1,
                                    "intencionPagoId": null,
                                    "refId": "152832",
                                    "descripcion": null,
                                    "editorId": 8,
                                    "fechaEdicion": "1698854375447"
                                },
                                {
                                    "pagoId": 866,
                                    "montoNominal": "8118243",
                                    "fecha": "1701280034000",
                                    "fechaValor": "1701280034000",
                                    "contratoId": 125,
                                    "medioDePagoId": 1,
                                    "intencionPagoId": null,
                                    "refId": "285616",
                                    "descripcion": null,
                                    "editorId": 89,
                                    "fechaEdicion": "1701971234317"
                                },
                                {
                                    "pagoId": 978,
                                    "montoNominal": "14505700",
                                    "fecha": "1703349697000",
                                    "fechaValor": "1703349697000",
                                    "contratoId": 125,
                                    "medioDePagoId": 1,
                                    "intencionPagoId": null,
                                    "refId": "550600",
                                    "descripcion": null,
                                    "editorId": 8,
                                    "fechaEdicion": "1704213698717"
                                }
                            ]
                        }
                        const com = v.row.ventas[k]?.reduce((p, x) => {
                            const Voa = x.clasesContrato.valorObjetoAhorroCAC * parseInt(x.indice.cac);
                            const pa = x.perPrimaAdjudicacion;
                            const adelIni = parseInt(x.adelantoInicialNominal);
                            const n = x.mesRefuerzoSemestral1 || x.mesRefuerzoSemestral2 ? 350 : 300;
                            const adelPrepac = x.adelantoRecurrenteCAC * parseInt(x.indice.cac);
                            const comisionStd = Math.max((((Voa * (1 - pa)) - adelIni) / n) + adelPrepac, (Voa * (1 - pa)) / n);
                            const comAdelA = Math.min(adelIni, comisionStd) * 0.2;
                            const comAdelB = Math.max((adelIni - comisionStd) * 0.013, 0);
                         
                            return p + comisionStd + comAdelA + comAdelB;
                        }, 0) || 0;


                        return `(${v.row.ventas[k]?.length ?? 0}) $${formatter.format(com / 100)}`;
                    }
                })
            }
            console.log('res', res);
            return res;
        };

        let rows = comisiones?.vendedores ?? [];

        const columns = [
            { field: 'vendedor', headerName: 'Vendedor', flex: 40, renderCell: v => v.row.apellido },
            ...getLastNMonths(8),
        ]

        return (
            <Box sx={{ height: 600, width: '100%' }}>
                <DataGridPro
                    getRowId={r => r.personaId}
                    rows={rows}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{
                        Toolbar: () => {
                            return <GridToolbarContainer><GridToolbarColumnsButton></GridToolbarColumnsButton> <GridToolbarFilterButton></GridToolbarFilterButton> <GridToolbarDensitySelector></GridToolbarDensitySelector>
                                {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport></GridToolbarExport>
                                    : ''}</GridToolbarContainer>
                        }
                    }}
                    componentsProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                    loading={fetching > 0}
                />
            </Box>);
    };

    return (
        <Fragment>
            <Header></Header>
            <ComisionesTable></ComisionesTable>
            <ComisionesDetailModal
                showComisionesDetails={showComisionesDetails}
                setShowComisionesDetails={setShowComisionesDetails}
                compState={{ isLoading: isLoading, contratos: contratos }}
            ></ComisionesDetailModal>
        </Fragment>
    )
};

export default ComisionesCat;